import {
  Provider,
  Signer,
  Vault,
  getChainConstant,
  getContract,
  increaseByPercentage,
} from 'nftx.js';
import { MIGRATOR_ZAP } from '@/domain/migrate';
import MigratorZap from '@/domain/migrate/abis/MigratorZap';
import { V2Position, V2Vault } from '@/core/migrate';

const migrateXToken = ({
  network,
  provider,
  signer,
  v2Vault,
  v3Vault,
  position,
  slippage,
}: {
  v2Vault: Pick<V2Vault, 'is1155' | 'vaultId'>;
  v3Vault: Pick<Vault, 'vaultId'>;
  position: Pick<V2Position, 'migrateOptions' | 'xToken'>;
  network: number;
  provider: Provider;
  signer: Signer;
  slippage: number;
}) => {
  const contract = getContract({
    address: getChainConstant(MIGRATOR_ZAP, network),
    abi: MigratorZap,
    provider,
    signer,
  });

  const vaultIdV2 = BigInt(v2Vault.vaultId);
  const is1155 = !!v2Vault?.is1155;
  const vaultIdV3 = BigInt(v3Vault.vaultId);
  const option = position.migrateOptions.find(
    (o) => o.vaultId === v3Vault.vaultId
  );
  if (!option) {
    throw new Error('Shares not found');
  }
  const shares = option.maxXToken;
  // TODO: how do we calculate this?
  const minWethToReceive = 0n;
  let sharesToWithdraw = increaseByPercentage(shares, slippage);
  if (sharesToWithdraw > position.xToken) {
    sharesToWithdraw = position.xToken;
  }

  return contract.write.v2InventoryToXNFT({
    args: [
      BigInt(vaultIdV2),
      sharesToWithdraw,
      is1155,
      vaultIdV3,
      minWethToReceive,
    ],
  });
};

export default migrateXToken;
